module.exports = __webpack_public_path__ + "static/img/img-finance-sharinglist-wait-sharing.a1b7286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/finance/sharinglist/img-finance-sharinglist-wait-sharing.png
// module id = sobA
// module chunks = 1